export default "__VITE_ASSET__CGBzzG1g__"